<template>
  <div>
    <organization-details-menu @refresh="getCurrentOrganization"/>

    <organization-form :loading="loading"
                       :organization="organization"
                       @submit="updateOrganization">
    </organization-form>
  </div>
</template>
<script>
  import OrganizationForm from './OrganizationForm'
  import OrganizationService from 'src/services/OrganizationService'
  import OrganizationDetailsMenu from './OrganizationDetailsMenu'
  import cloneDeep from 'lodash/cloneDeep'

  export default {
    name: 'organization-edit',
    components: {
      OrganizationForm,
      OrganizationDetailsMenu
    },
    data () {
      return {
        loading: false,
        organization: {},
        initialOrganization: {}
      }
    },
    methods: {
      async updateOrganization ({model}) {
        try {
          this.loading = true
          await OrganizationService.update(model.id, model)
        } finally {
          this.loading = false
        }
      },
      async getCurrentOrganization () {
        let {data} = await OrganizationService.getById(this.$route.params.id)
        this.organization = {
          ...data,
          segment_ids: data.organisation_segments ? data.organisation_segments.map(s => s.id) : []
        }
        this.initialOrganization = cloneDeep(data)
        this.$store.commit('organization/SET_CURRENT_ORGANIZATION', data)
      }
    },
    async created () {
      await this.getCurrentOrganization()
    }

  }
</script>
<style>
</style>
